"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientDates_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PatientDates_Factory = /** @class */ (function () {
    function PatientDates_Factory() {
    }
    PatientDates_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Created: Date_Factory_1.Date_Factory.CreateIncoming(model.Created, { ignoreTimePortion: true }),
            FirstVisit: Date_Factory_1.Date_Factory.CreateIncoming(model.FirstVisit, { ignoreTimePortion: true }),
            FirstVisitLocationId: model.FirstVisitLocationId,
            LastBitewing: Date_Factory_1.Date_Factory.CreateIncoming(model.LastBitewing, { ignoreTimePortion: true }),
            LastInsurancePayment: Date_Factory_1.Date_Factory.CreateIncoming(model.LastInsurancePayment, { ignoreTimePortion: true }),
            LastPanoFMX: Date_Factory_1.Date_Factory.CreateIncoming(model.LastPanoFMX, { ignoreTimePortion: true }),
            LastPatientPayment: Date_Factory_1.Date_Factory.CreateIncoming(model.LastPatientPayment, { ignoreTimePortion: true }),
            LastPayment: Date_Factory_1.Date_Factory.CreateIncoming(model.LastPayment, { ignoreTimePortion: true }),
            LastStatement: Date_Factory_1.Date_Factory.CreateIncoming(model.LastStatement, { ignoreTimePortion: true }),
            LastVisit: Date_Factory_1.Date_Factory.CreateIncoming(model.LastVisit, { ignoreTimePortion: true }),
            LastVisitLocationId: model.LastVisitLocationId,
            RecordId: model.RecordId,
        };
        return result;
    };
    PatientDates_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Created: Date_Factory_1.Date_Factory.CreateOutgoing(model.Created, { ignoreTimePortion: true }),
            FirstVisit: Date_Factory_1.Date_Factory.CreateOutgoing(model.FirstVisit, { ignoreTimePortion: true }),
            FirstVisitLocationId: model.FirstVisitLocationId,
            LastBitewing: Date_Factory_1.Date_Factory.CreateOutgoing(model.LastBitewing, { ignoreTimePortion: true }),
            LastInsurancePayment: Date_Factory_1.Date_Factory.CreateOutgoing(model.LastInsurancePayment, { ignoreTimePortion: true }),
            LastPanoFMX: Date_Factory_1.Date_Factory.CreateOutgoing(model.LastPanoFMX, { ignoreTimePortion: true }),
            LastPatientPayment: Date_Factory_1.Date_Factory.CreateOutgoing(model.LastPatientPayment, { ignoreTimePortion: true }),
            LastPayment: Date_Factory_1.Date_Factory.CreateOutgoing(model.LastPayment, { ignoreTimePortion: true }),
            LastStatement: Date_Factory_1.Date_Factory.CreateOutgoing(model.LastStatement, { ignoreTimePortion: true }),
            LastVisit: Date_Factory_1.Date_Factory.CreateOutgoing(model.LastVisit, { ignoreTimePortion: true }),
            LastVisitLocationId: model.LastVisitLocationId,
            RecordId: model.RecordId,
        };
        return result;
    };
    return PatientDates_Factory;
}());
exports.PatientDates_Factory = PatientDates_Factory;
